<div class="container-fluid hero mx-0-auto  backgroundMain   px-4 py-4">
  <div class="row flex-lg-row-reverse align-items-center g-5 ">
    <div class="col-10 col-sm-8 col-lg-6">
      <img src="{{ routeImageMain }}"  class="d-block mx-lg-auto img-fluid imgHero" loading="lazy" alt="MoviLink" >
    </div>
    <div class="col-lg-6  ">
      <div class="my-3 mx-5">
        <span class=" fs-4 spanHeroTitleHero fw-bolder mb-3  ">{{ title }}</span>
      </div>
      <div class="texts mx-5 w-75">
        <h3 class=" lh-1 fs-2  fw-bold">{{ subtitle1 }}</h3>

        <span class="lh-1  fs-5  text-light ">{{ subtitle2 }}</span>
        <br>
        <br>
        <span class="lh-1  fs-5   text-light mt-2">{{ subtitle3 }}</span>
      </div>
    </div>

  </div>
</div>
